import type { SanityPageBuilderIntroHeadlineBSection, SanityPageBuilderSection } from "@ouster/shared";
import { IntroHeadlineBBlockView } from "~/features/blocks/inventory/intro-headline-b";
import { toCraftLink } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderIntroHeadlineBSection;
  };
};
export function SanityIntroHeadlineBSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  const hasMedia = hasRenderableSanityMedia(sectionContent.media);
  return <IntroHeadlineBBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} eyebrow={sectionContent.eyebrow} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} headlineAccent={sectionContent.headlineAccent} mediaDesktop={hasMedia ? <SanityMediaFigure fit="cover" media={sectionContent.media} sizes="lg:50vw" /> : undefined} mediaMobile={hasMedia ? <SanityMediaFigure media={sectionContent.media} ratio="3/2" sizes="lg:50vw" /> : undefined} mediaPosition={sectionContent.mediaPosition} mode={sectionSettings?.mode || "light"} primaryLink={toCraftLink(sectionContent.primaryLink)} secondaryLink={toCraftLink(sectionContent.secondaryLink)} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} theme={sectionSettings?.theme || "white"} />;
}